/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    StorageNodeMini,
    StorageNodeMiniFromJSON,
    StorageNodeMiniFromJSONTyped,
    StorageNodeMiniToJSON,
} from './';

/**
 * 
 * @export
 * @interface BeeGFSTarget
 */
export interface BeeGFSTarget {
    /**
     * 
     * @type {StorageNodeMini}
     * @memberof BeeGFSTarget
     */
    node?: StorageNodeMini | null;
    /**
     * 
     * @type {number}
     * @memberof BeeGFSTarget
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof BeeGFSTarget
     */
    host: string;
    /**
     * 
     * @type {number}
     * @memberof BeeGFSTarget
     */
    storagePool: number;
    /**
     * 
     * @type {number}
     * @memberof BeeGFSTarget
     */
    sizeTotal: number;
    /**
     * 
     * @type {number}
     * @memberof BeeGFSTarget
     */
    sizeUsed: number;
    /**
     * 
     * @type {number}
     * @memberof BeeGFSTarget
     */
    sizeFree: number;
    /**
     * 
     * @type {boolean}
     * @memberof BeeGFSTarget
     */
    online: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BeeGFSTarget
     */
    consistent: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof BeeGFSTarget
     */
    errors: Array<string>;
}

export function BeeGFSTargetFromJSON(json: any): BeeGFSTarget {
    return BeeGFSTargetFromJSONTyped(json, false);
}

export function BeeGFSTargetFromJSONTyped(json: any, ignoreDiscriminator: boolean): BeeGFSTarget {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'node': !exists(json, 'node') ? undefined : StorageNodeMiniFromJSON(json['node']),
        'id': json['id'],
        'host': json['host'],
        'storagePool': json['storage_pool'],
        'sizeTotal': json['size_total'],
        'sizeUsed': json['size_used'],
        'sizeFree': json['size_free'],
        'online': json['online'],
        'consistent': json['consistent'],
        'errors': json['errors'],
    };
}

export function BeeGFSTargetToJSON(value?: BeeGFSTarget | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'node': StorageNodeMiniToJSON(value.node),
        'id': value.id,
        'host': value.host,
        'storage_pool': value.storagePool,
        'size_total': value.sizeTotal,
        'size_used': value.sizeUsed,
        'size_free': value.sizeFree,
        'online': value.online,
        'consistent': value.consistent,
        'errors': value.errors,
    };
}


